import React from 'react';
import styled  from 'styled-components'

const ARMSFOOTER = styled.footer`
@media screen and (min-width: 48rem) {
    & section.logo {
 font-style: normal;
font-weight: 900;
font-size: 35px;
line-height: 56px;
        grid-column-start: 1;
    }
}

@media screen and (max-width: 48rem) {
 & section {
     grid-column-start: 1;
     grid-column-end: 5;
 }
 & section.logo {
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 35px;
    line-height: 56px;
 }

 & article:first-of-type {
    grid-column-start: 2;
    grid-column-end: 5;
 }
 & article:first-of-type + article {
    grid-column-start: 2;
    grid-column-end: 5;
 }
 & article:first-of-type + article + article {
    grid-column-start: 2;
    grid-column-end: 5;
 }

}
overflow-x: hidden;
display: grid;
grid-template-columns: 40% 20% 20% 20%;
grid-gap: 12px;
background: white;
justify-content: space-around;
padding: 3rem .01rem;
align-content: center;
align-items: center;

& section:last-child {

@media screen and (max-width: 48rem) {
    & {
        padding-right: 2rem;
    }
 & p:first-child {
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 3;
    justify-self: center;
    margin-top: 2rem;
 }

 & p:first-child + ul {
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 2;
    margin-top: 2rem;
    padding-left: 1.2rem;
  }

 & p:first-child + ul + ul{
    grid-column-start: 1;
    grid-column-end: 5;
    grid-row-start: 1;
  }
    }

margin-top: 5rem;
font-size: 14px;
display: grid;
grid-template-columns: 27% 35% 35%;
grid-column-start: 1;
grid-column-end: 5;

& ul {
    display: flex;
    justify-content: space-around;
    list-style-type: none;
}
}

& article h4 {
    color: #271e2a;
    @media screen and (max-width: 48rem) {
        font-size: larger;
     }
}

& article ul {
    list-style-type: none;
    line-height: 2rem;
    padding-left: 0;
    font-size: 14px;

    & a {
        color: #292727;
        text-decoration: none;
        &:hover {
            text-decoration: underline
        }
    }
}
`

 const Footer = () => {
     
    return ( 
        <>

<ARMSFOOTER>
 <span id='down'></span>
 
    <section id="dashH" class="logo" style={{justifySelf:'center'}}>Iamwealthy</section>

    <article>

        <h4>Community</h4>
        <ul>
            <li><a href="/">Student life</a> </li>
            <li><a href="/">Business center</a> </li>
            <li><a href="/">Family</a> </li>
            <li><a href="/">Event && Conference</a> </li>
         </ul>

    </article>

    <article>

        <h4 style={{paddingTop: '2rem'}}>Features</h4>
        <ul>
            <li><a href="/">Seamless recording</a> </li>
            <li><a href="/">Offline support</a> </li>
            <li><a href="/">Visualisation</a> </li>
            <li><a href="/"> Study library </a> </li>
            <li><a href="/">Automated analysis </a> </li>
         </ul>
    </article>

    <article>
        <h4>Reach Outs</h4>
        <ul>
            <li><a href="/">Earn free loans</a> </li>
            <li><a href="/">Apply as a merchant</a> </li>
            <li><a href="/">Gallery</a> </li>
            <li><a href="/">Learn more</a> </li>
          </ul>
    </article>
 
<section>
    <p style={{paddingLeft: '2rem'}}>
    © 2020 Iamwealthy International. All right reserved
    </p>

    <ul>
        <li><a href="/">  Terms of service </a></li>
        <li><a href="/"> Privacy Policy  </a></li>
        <li><a href="/"> Security  </a></li>
        <li><a href="/"> Sitemap  </a></li>
    </ul>

    <ul>
        <li><a href='/'><i class="fa fa-twitter" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>

        <li><a href='/'><i class="fa fa-facebook-f" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>

        <li><a href='/'><i class="fas fa-mail-bulk" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>

        <li><a href='/'><i class="fas fa-globe" style={{fontSize:"36px", color: '#271e2a'}}></i></a> </li>
         
    </ul>
</section>

</ARMSFOOTER>


        </>
     );
}
 
export default Footer;